import styled from "styled-components";
import { Titulo as TituloBase } from "../styles";

export const TituloRecusas = styled(TituloBase)<{ $semRecusas?: boolean }>`
    ${({ $semRecusas }) => $semRecusas && "margin: 0 !important;"}
`;

export const ContagemRecusas = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 27px;
    min-width: 16px;
    line-height: 18px;
    padding: 4px;
    font-size: 11px;
    font-weight: 600;
    background-color: ${({ theme }) => theme.colors.interfaceGray300};
    color: ${(props: any) => props.theme.colors.pureWhite};
    border-radius: 4px;
    text-align: center;
`;

export const ParagrafoSemRecusas = styled.p`
    color: ${(props: any) => props.theme.colors.c64748b} !important;
    margin: 16px 0 0 0 !important;
`;

export const CardRecusa = styled.div`
    background-color: ${(props: any) => props.theme.colors.cf1f5f94d};
    border: 1px solid ${(props: any) => props.theme.colors.ce2e8f0};
    border-radius: 6px;
    padding: 12px;
    margin-bottom: 12px;
    
    &:last-child {
        margin-bottom: 0;
    }
`;

export const HeaderRecusa = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
`;

export const AvatarContainer = styled.div`
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background-color: ${({ theme }) => theme.colors.interfacePure0 || '#FFFFFF'};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.1);
`;

export const InfoContainer = styled.div`
    flex: 1;
    min-width: 0;
`;

export const NomeContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    flex-wrap: wrap;
`;

export const NomeProfissional = styled.strong`
    color: ${(props: any) => props.theme.colors.interfaceText};
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
`;

export const CodigoProfissional = styled.span`
    color: ${(props: any) => props.theme.colors.c64748b};
    font-size: 11px;
    font-weight: 400;
`;

export const DataRelativa = styled.span`
    color: ${(props: any) => props.theme.colors.c64748b};
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const BotaoExpandir = styled.span`
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 8px;
    border-radius: 6px;
    transition: background-color 0.2s ease;
    min-width: 32px;
    min-height: 32px;
    
    &:hover {
        background-color: ${(props: any) => props.theme.colors.cf8f9fa};
    }
`;
